import {
  endOfMonth,
  endOfWeek,
  format,
  getWeek,
  isFuture,
  isSameWeek,
  isSunday,
  nextSaturday,
  previousSunday,
  startOfMonth,
  startOfWeek,
} from 'date-fns';
import { StorePerformanceInterval } from '../constants';

// Using the current date, returns a date range for a week retuns a date range from a Sun to Sat
export const getBussinessWeekRange = (currentDate: Date): { fromDate: Date; toDate: Date } => {
  const isCurrentDateSunday = isSunday(currentDate);

  if (isCurrentDateSunday) {
    const nextSaturdayDate = nextSaturday(currentDate);
    return { fromDate: currentDate, toDate: nextSaturdayDate };
  }

  const previousSundayDate = previousSunday(currentDate);
  const nextSaturdayDate = nextSaturday(currentDate);

  return { fromDate: previousSundayDate, toDate: nextSaturdayDate };
};

export const isInSameWeek = (dayA: Date, dayB: Date | null | undefined) => {
  if (!dayB) {
    return false;
  }

  return isSameWeek(dayA, dayB);
};

export const getWeekBounds = (date: Date) => {
  // Adjust the first day of the week if needed (e.g., set to Sunday hetr)
  const weekStart = startOfWeek(date, { weekStartsOn: 0 }); // Sunday as the first day of the week
  let weekEnd = endOfWeek(date, { weekStartsOn: 0 }); // Saturday as the last day of the week

  // If the week ends on a future day, set it to the current day
  if (isFuture(weekEnd)) {
    weekEnd = new Date(); // Send current day
  }

  return { weekStart, weekEnd };
};

export const getMonthBounds = (date: Date) => {
  const monthStart = startOfMonth(date);
  let monthEnd = endOfMonth(date);

  if (isFuture(monthEnd)) {
    monthEnd = new Date(); // Send current day
  }
  return { monthStart, monthEnd };
};

export const format24Hour = (hour: string) => {
  const hourNumber = Number.parseInt(hour);
  return hourNumber < 10 ? `0${hourNumber}:00` : `${hourNumber}:00`; // Formats as '00:00', '01:00', etc.
};

export const getDatePickerLabel = (date: Date, interval: StorePerformanceInterval, dateLabelString: string) => {
  if (interval === StorePerformanceInterval.MONTHLY) {
    return `${format(date, 'MMMM yyyy')}`;
  } else if (interval === StorePerformanceInterval.WEEKLY) {
    return `${dateLabelString} ${getWeek(date)}`;
  } else {
    return format(date, 'dd-MMM-yyyy');
  }
};

export const formatDateWithTimestamp = (time: string): string => {
  return format(new Date(time), "yyyy-MM-dd 'at' hh:mm a");
};
